const BlurFoundationsThemes = {
    blur_00: '0rem',
    blur_25: '0.125rem',
    blur_50: '0.25rem',
    blur_100: '0.5rem',
    blur_150: '0.9375rem',
};
export { BlurFoundationsThemes };
//# sourceMappingURL=blur-foundations.themes.js.map